import { render, staticRenderFns } from "./AddPaymentDialog.vue?vue&type=template&id=3b84638e&scoped=true"
import script from "./AddPaymentDialog.vue?vue&type=script&lang=js"
export * from "./AddPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84638e",
  null
  
)

export default component.exports